import type { UUID, TranslatedField } from "../../basetypes";

export type AvailableMailingList = {
  id: UUID;
  name: string;
  optinText: TranslatedField;
}